<div class="loading">
    <div class="loader">Redirecting...</div>
</div>